import rng from './support/rng';
import bytesToUuid from './support/bytesToUuid';
export function uuidv4(options = {}, buf, offset = 0) {
    const rnds = options.random || (options.rng || rng)();
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    if (buf) {
        for (let ii = 0; ii < 16; ++ii) {
            buf[offset + ii] = rnds[ii];
        }
    }
    return buf || bytesToUuid(rnds);
}
export default uuidv4;
